import { LinkingOptions } from '@react-navigation/native';
import type { RootStackParamList } from '../types/navigation';

// Definición de los posibles deeplinks
const linkingConfig: LinkingOptions<RootStackParamList> = {
  prefixes: [
    'gymbro://', 
    'https://gymbro.uy', 
    'https://www.gymbro.uy'
  ],
  config: {
    screens: {
      // Configuración para las pantallas autenticadas
      MainTabs: {
        screens: {
          // Tab screens
          Profile: 'profile',
          Workout: 'workout',
          Routines: 'routines',
          Exercises: 'exercises',
          Progress: 'progress',
        }
      },
      // Pantallas legales
      TermsConditions: 'terms',
      PrivacyPolicy: 'privacy',
      
      // Para el flujo de autenticación
      Login: 'login',
      Register: 'register',
      PasswordRecovery: 'recover',
      
      // Otras pantallas del stack principal
      ProfileSetup: 'profile/setup',
      FriendProfile: 'friend/:friendId',
      ExerciseDetail: 'exercise/:exerciseId/:routineId/:dayOrder',
      EditRoutine: 'routine/edit/:routineId',
      CreateRoutine: 'routine/create',
      JoinRoutine: 'routine/join',
      CreateExercise: 'exercise/create',
      ExerciseLibraryDetail: 'exercise/detail/:exerciseId',
      RoutineSharing: 'routine/share/:routineId',
      WeightTracking: 'weight/:exerciseId',
      FriendManagement: 'friends',
    },
  },
};

export default linkingConfig; 